import React, { useContext } from 'react';
import ReactJson from 'react-json-view';
import modelContext from '../modelContext';
import './VisualizeModel.css'

export default function VisualizeModel() {
	const model = useContext(modelContext);

	return (
		<div className="viewer">
			<ReactJson src={model.modelJson['cell4d:environmentVariables']} name="Environment" theme="summerfruit:inverted" enableClipboard={false} displayDataTypes={false} indentWidth={2} collapsed={true} />
			<ReactJson src={model.modelJson.listOfCompartments.compartment} name="Compartments" theme="summerfruit:inverted" enableClipboard={false} displayDataTypes={false} indentWidth={2} collapsed={true} />
			<ReactJson src={model.modelJson.annotSpecies["cell4d:speciesType"]} name="Base molecules" theme="summerfruit:inverted" enableClipboard={false} displayDataTypes={false} indentWidth={2} collapsed={true} />
			<ReactJson src={model.modelJson.listOfSpecies.species} name="Species" theme="summerfruit:inverted" enableClipboard={false} displayDataTypes={false} indentWidth={2} collapsed={true} />
			<ReactJson src={model.modelJson.listOfReactions.reaction} name="Reactions" theme="summerfruit:inverted" enableClipboard={false} displayDataTypes={false} indentWidth={2} collapsed={true} />
			<ReactJson src={model.modelJson.listOfEvents.event} name="Events" theme="summerfruit:inverted" enableClipboard={false} displayDataTypes={false} indentWidth={2} collapsed={true} />
		</div>
	);
};
